import React, { useState, useEffect } from 'react';
import { Grid, FormControl, InputLabel, MenuItem, Typography, Button } from '@mui/material';
import styled from '@mui/material/styles/styled';
import { UseScreen } from '../hooks/UseScreen.hook';
import { useDispatch, useSelector } from 'react-redux';
import SuccessModal from '../components/SuccessModal';
import { useNavigate } from 'react-router-dom';
import { DailySummaryTable } from '../components/datatables/index'
import { PrimaryOutlinedButton, PrimaryLightInput, SecondaryOutlinedButton } from '../theme/index';

const Room = styled(Grid)(({ theme }) => `
    :hover{
      cursor: pointer
    }
`)

const createReservationRoute = '/bookings';

const DailySummary = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const modalStatus = useSelector( state => state.Modal.modalState );
  const navigate = useNavigate();

  const [ showModal, setShowModal ] = useState(false);

  useEffect( () => {
    setShowModal(modalStatus);
  }, [modalStatus] );

  const tablesTitle = () => {
    return ( screenWidth <= 500 ) ? { fontSize: '1.5rem', fontFamily: 'Roboto-Bold'  } : { fontSize: '2rem', fontFamily: 'Roboto-Bold'  };
  }
  
  return (
    <Grid container px={4}>
      <Grid item xs={12}>
        <h2 style={{ fontFamily: 'Roboto-Thin' }}>Resumen diario</h2>
      </Grid>
      {
        showModal &&
          <SuccessModal view='cleaningRoom' />
      }
      
      <Grid item xs={12} sx={{ my: 5 }}>
        <DailySummaryTable />
      </Grid>
    </Grid>
  )
}

export default DailySummary